import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatZAR(amount) {
  if (amount === null || amount === undefined) return "";
  const n = Number(amount);
  return "R " + n.toLocaleString("en-ZA", { maximumFractionDigits: 0 });
}

// Psychological round to nearest R...49 / R...99
function psychoRound(n) {
  const r = Math.round(n / 50) * 50;
  return r - 1;
}

const DENSITY_LEVELS = { "150%": 0, "180%": 1, "200%": 2, "250%": 3 };

/**
 * Compute dynamic price based on selected length & density relative to product base.
 * - +8% per +2 inches over base length (capped at +60%)
 * - -4% per -2 inches under base length (floored at -16%)
 * - Density: +12% per level up from product's own base density, -8% per level down (floor at -16%)
 */
export function priceFor(product, length, density) {
  if (!product) return 0;
  const baseLen = product.length_inches;
  const len = length ?? baseLen;
  const lenDiff = len - baseLen;
  let lenMult = 1;
  if (lenDiff > 0) lenMult = 1 + Math.min(lenDiff / 2, 8) * 0.08;
  else if (lenDiff < 0) lenMult = 1 + Math.max(lenDiff / 2, -4) * 0.04;

  const baseDenLvl = DENSITY_LEVELS[product.density] ?? 1;
  const selDenLvl = DENSITY_LEVELS[density || product.density] ?? baseDenLvl;
  const denDiff = selDenLvl - baseDenLvl;
  let densityMult = 1;
  if (denDiff > 0) densityMult = 1 + denDiff * 0.12;
  else if (denDiff < 0) densityMult = 1 + Math.max(denDiff, -2) * 0.08;

  return psychoRound(product.price * lenMult * densityMult);
}

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => (typeof e?.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return String(d);
}
